var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"osNav"}},[_c('el-header'),_vm._v(" "),_c('div',{staticClass:"top"},[_c('user-info')],1),_vm._v(" "),_c('div',{staticClass:"bottom"},[_c('nav-module')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-377b89ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/osNav/osNav.vue
// module id = null
// module chunks = 